import { Component, inject, model, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DocumentiService } from 'src/app/core/documenti.service';

@Component({
  selector: 'app-profile-menu-show-permission',
  standalone: true,
  imports: [DialogModule, ButtonModule, CommonModule],
  template: `
    <li role="menuitem">
      <a (click)="showDialog()">
        <i class="fa fa-fw fa-award"></i>
        <span>Visualizza Permessi</span>
      </a>
    </li>
    <p-dialog [modal]="true" [(visible)]="visible" appendTo="body" [style]="{width:'25%'}">
      <p-header>
        <span>Visualizza Permessi</span>
      </p-header>
      <div class="advanced-form">
        <div class="grid">
          <div class="col-12">
            Si dispone delle autorizzazioni per accedere ai documenti con 
          </div>
          <div class="col-offset-1 col-3 text-right">
            Qualifica :
          </div>
          <div class="col-8">
            <span class="font-bold">{{qualificationPermissions()}}</span>
          </div>          
        </div>
      </div>
      <p-footer>
        <button pButton type="button" label="Chiudi" class="p-button-secondary" title="Chiudi" (click)="showDialog()"></button>
      </p-footer> 
    </p-dialog>
  `
})
export class ProfileMenuShowPermissionComponent {

  private readonly documentiService = inject(DocumentiService);
  public visible = model<boolean>(false);
  public qualificationPermissions = signal<string>('');
  
  public showDialog(): void {
    this.visible.set(!this.visible());

    if ( this.visible()) {
      this.loadPermissions();
    }
  }

  private loadPermissions(): void {
    this.documentiService.getPermissions('qualification')
    .subscribe( permsissions => {
        this.qualificationPermissions.set(permsissions.join( ', '));
    });
  }

}